var _defs, _path, _path2, _path3, _circle, _use, _use2, _use3, _use4, _path4, _path5, _use5, _use6, _use7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGd = function SvgGd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    transform: "rotate(18 0 -1)",
    d: "M0-1v1h.5",
    id: "a"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1 1)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(72)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(144)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(216)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(288)",
    xlinkHref: "#b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 .05h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#007a5e",
    d: "M67.2 67.2h505.6v345.6H67.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2 67.25h505.6L67.2 412.85h505.6z",
    fill: "#fcd116"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 319.917,
    cy: 240.05,
    r: 57.6,
    fill: "#ce1126"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#c",
    transform: "matrix(52.8 0 0 52.8 319.917 240.05)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    x: -100,
    transform: "translate(-30.327)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    id: "d",
    xlinkHref: "#c",
    transform: "matrix(31.2 0 0 31.2 320 33.65)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#d",
    x: 100,
    transform: "translate(30.327)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.315 240.706c7.206 13.424 21.224 28.032 33.466 33.168.196-13.632-4.64-31.104-11.255-45.024l-22.21 11.856z",
    fill: "#ce1126"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.096 194.658c10.446 21.776-27.093 73.728 35.45 85.904-7.716-10.528-12.69-27.904-10.809-41.856 13.122 4.992 26.928 19.6 32.508 30.768 16.368-59.44-41.984-55.824-57.15-74.816z",
    fill: "#fcd116"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(-30.327 414.55)",
    x: -100,
    xlinkHref: "#d",
    width: "100%",
    height: "100%"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    transform: "matrix(31.2 0 0 31.2 320 448.2)",
    xlinkHref: "#c",
    width: "100%",
    height: "100%"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(30.327 414.55)",
    x: 100,
    xlinkHref: "#d",
    width: "100%",
    height: "100%"
  })));
};
export default __webpack_public_path__ + "assets/c0bf15311a8ed3bef0965aecfeaca08a.svg";
export { SvgGd as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/gd.svg